import React from 'react'
import { connect } from 'react-redux'
import { GET_VERSION_INFO } from 'requests'
import format from 'date-fns/format'

const VersionPage = ({isAdmin}) => {
  const [versionHTML, setVersionHTML] = React.useState(null);

  React.useEffect(() => {
    if(isAdmin){
      GET_VERSION_INFO(html => {
        setVersionHTML(html)
      }, err => {
        console.error(err)
      })
    }
  }, [isAdmin])

  return (
    <div className="body">
      <strong>Build Number:</strong> {process.env.BUILD_NUMBER}
      <br /><br /><strong>Build Date:</strong> {format(new Date(process.env.BUILD_DATE), 'MM/dd/yyyy h:mm:ss a')}
      <br /><br /><strong>Git Version:</strong> {process.env.GIT_VERSION}
      <br /><br /><strong>Git Commit Hash:</strong> {process.env.GIT_COMMIT_HASH}
      <br /><br /><strong>Git Branch:</strong> {process.env.GIT_BRANCH}
      {
        versionHTML && isAdmin &&
        <div className="version-table" dangerouslySetInnerHTML={{__html: versionHTML}} />
      }
    </div>
  )
}

export default connect(
  state => ({
    isAdmin: state.auth.USER_GROUP === 'ADMIN_WEB' || state.auth.USER_GROUP === 'ADMIN'
  })
)(VersionPage)



// WEBPACK FOOTER //
// ./src/components/Version/Version.js